import {
  LIST_USER_CLINICS_FAIL,
  LIST_USER_CLINICS_REQUEST,
  LIST_USER_CLINICS_RESET,
  LIST_USER_CLINICS_SUCCESS,
  CLINIC_CREATE_FAIL,
  CLINIC_CREATE_REQUEST,
  CLINIC_CREATE_RESET,
  CLINIC_CREATE_SUCCESS,
  CLINIC_DETAILS_FAIL,
  CLINIC_DETAILS_REQUEST,
  CLINIC_DETAILS_RESET,
  CLINIC_DETAILS_SUCCESS,
  CLINIC_UPDATE_FAIL,
  CLINIC_UPDATE_REQUEST,
  CLINIC_UPDATE_RESET,
  CLINIC_UPDATE_SUCCESS,
} from "../constants/clinicConstants";

export const newClinicReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case CLINIC_CREATE_REQUEST:
      return { loading: true };
    case CLINIC_CREATE_SUCCESS:
      return { loading: false, newClinic: action.payload };
    case CLINIC_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CLINIC_CREATE_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const clinicDetailsReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case CLINIC_DETAILS_REQUEST:
      return { loading: true };
    case CLINIC_DETAILS_SUCCESS:
      return { loading: false, clinic: action.payload };
    case CLINIC_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case CLINIC_DETAILS_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const clinicUpdateReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case CLINIC_UPDATE_REQUEST:
      return { loading: true };
    case CLINIC_UPDATE_SUCCESS:
      return { loading: false, updatedClinic: action.payload };
    case CLINIC_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case CLINIC_UPDATE_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};

export const userClinicsReducer = (state = { noRequest: true }, action) => {
  switch (action.type) {
    case LIST_USER_CLINICS_REQUEST:
      return { loading: true };
    case LIST_USER_CLINICS_SUCCESS:
      return { loading: false, userClinics: action.payload };
    case LIST_USER_CLINICS_FAIL:
      return { loading: false, error: action.payload };
    case LIST_USER_CLINICS_RESET:
      return { noRequest: true };
    default:
      return state;
  }
};
